import { getGlobalVariables } from '@libs/hooks';
import { ReactNode, useEffect, useState } from 'react';

const localStorageKey = 'consumer-theme';

const isDarkThemeDisabled = () => {
    const { disableDarkTheme } = getGlobalVariables('disableDarkTheme');
    return disableDarkTheme === 'true';
};

const getCurrentTheme = () => {
    if (isDarkThemeDisabled()) {
        return 'light';
    }
    let theme = 'light';
    if (window?.matchMedia) {
        const isMatchesDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
        theme = isMatchesDark ? 'dark' : 'light';
    }
    return theme;
};
const getCurrentThemeForText = () => getCurrentTheme();

const useThemeDetector = () => {
    const [theme, setTheme] = useState(getCurrentTheme());

    useEffect(() => {
        if (isDarkThemeDisabled()) {
            document.documentElement.setAttribute('data-theme', 'light');
            localStorage?.setItem(localStorageKey, 'light');
            return;
        }

        const mediaQueryList = window?.matchMedia('(prefers-color-scheme: dark)');
        const setQuery = () => {
            const currentTheme = getCurrentTheme();
            setTheme(currentTheme);
            document.documentElement.setAttribute('data-theme', currentTheme);
            localStorage?.setItem(localStorageKey, currentTheme);
        };
        setQuery();
        mediaQueryList?.addEventListener('change', setQuery);

        return () => {
            mediaQueryList?.removeEventListener('change', setQuery);
        };
    }, []);
    return theme;
};

interface ProviderProps {
    children: ReactNode;
}

const ConsumerThemeProvider = ({ children }: ProviderProps) => {
    useThemeDetector();

    return children;
};
export { ConsumerThemeProvider, useThemeDetector, getCurrentThemeForText };
